import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ListFiltersBar } from '../../shared/table/ListFiltersBar';
import { TablePagination } from '../../shared/table/TablePagination';
import { useSettingsUsersManagement } from './settings-users-management/hooks';
import {
    searchFieldLabelMap,
    searchFieldOptions,
    statusOptions,
} from './settings-users-management/helpers';
import {
    SettingsUsersStatusConfirmModal,
    SettingsUsersTable,
} from './settings-users-management/components';

export const SettingsUsersManagementContent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { token, id: currentUserId } = useSelector((state) => state.auth);

    const {
        users,
        isLoading,
        error,
        savingUserId,
        searchField,
        setSearchField,
        searchTerm,
        setSearchTerm,
        statusFilter,
        setStatusFilter,
        offset,
        setOffset,
        limit,
        total,
        hasNext,
        hasPrev,
        confirmState,
        openToggleDialog,
        closeToggleDialog,
        handleToggleActive,
        handleResendInvitation,
        handleClearFilters,
        handleRowsPerPageChange,
    } = useSettingsUsersManagement({
        token,
        dispatch,
    });

    return (
        <div>
            <ListFiltersBar
                searchField={searchField}
                onSearchFieldChange={(nextValue) => {
                    setSearchField(nextValue);
                    setOffset(0);
                }}
                searchFieldOptions={searchFieldOptions}
                searchTerm={searchTerm}
                onSearchTermChange={(nextValue) => {
                    setSearchTerm(nextValue);
                    setOffset(0);
                }}
                statusFilter={statusFilter}
                onStatusFilterChange={(nextValue) => {
                    setStatusFilter(nextValue);
                    setOffset(0);
                }}
                statusOptions={statusOptions}
                rowsPerPage={limit}
                onRowsPerPageChange={handleRowsPerPageChange}
                rowsOptions={[10, 25, 50]}
                onClearFilters={handleClearFilters}
                searchPlaceholder="Buscar usuarios"
            />

            {error && <div className="settings-users-feedback settings-users-feedback--error">{error}</div>}

            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                <div className="text-muted fs-12">
                    {searchTerm.trim()
                        ? `Resultados para ${searchFieldLabelMap[searchField] || 'Búsqueda'}: "${searchTerm.trim()}"`
                        : 'Listado general de usuarios'}
                </div>
                <div className="text-muted fs-12">Mostrando {users.length} de {total}</div>
            </div>

            <SettingsUsersTable
                users={users}
                isLoading={isLoading}
                total={total}
                savingUserId={savingUserId}
                currentUserId={currentUserId}
                onEdit={(user) => navigate(`/settings/users/edit/${user._id}`)}
                onResendInvitation={handleResendInvitation}
                onOpenToggleDialog={openToggleDialog}
            />

            <TablePagination
                total={total}
                limit={limit}
                offset={offset}
                hasNext={hasNext}
                hasPrev={hasPrev}
                onOffsetChange={setOffset}
                isLoading={isLoading}
            />

            <SettingsUsersStatusConfirmModal
                open={confirmState.open}
                user={confirmState.user}
                nextActive={confirmState.nextActive}
                isSaving={Boolean(savingUserId)}
                onCancel={closeToggleDialog}
                onConfirm={handleToggleActive}
            />

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover
                draggable
                theme="light"
            />
        </div>
    );
};
